<template>
  <div
    class="text botter-conversation"
    v-if="con.payload || con.text.body || con.text"
  >
    <div class="d-flex align-end" :class="getAlignment()">
      <user-chat-image
        :sender="con.sender"
        v-if="con.sender.sender_type === 'BOT'"
      />
      <div :class="['botter-text', getColor()]">
        <p
          v-if="con.interactive"
          v-html="
            common.formatText(con.interactive[con.interactive.type].title)
          "
          :class="
            common.getTextAlignment(con.payload || con.text.body || con.text)
          "
          :style="{
            float: con.sender.sender_type === 'BOT' ? 'left' : 'right',
          }"
        />
        <p
          v-else
          v-html="common.formatText(con.payload || con.text.body || con.text)"
          :class="
            common.getTextAlignment(con.payload || con.text.body || con.text)
          "
          :style="{
            float: con.sender.sender_type === 'BOT' ? 'left' : 'right',
          }"
        />
      </div>
    </div>
    <div class="chat-date d-flex" :class="getAlignment()">
      {{
        $moment(con.created_at)
          .add(parseInt($store.state.settings.settings.timeZoneShift), "hours")
          .format("MMMM Do YYYY")
      }}
      {{
        $moment(con.created_at)
          .add(parseInt($store.state.settings.settings.timeZoneShift), "hours")
          .format("h:mm a")
      }}
    </div>
  </div>
</template>

<script>
import userChatImage from "./common/userChatImage";
import common from "../../../../utils/common";
export default {
  name: "textData",
  components: {
    userChatImage,
  },
  props: {
    con: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },

  data() {
    return {
      common,
    };
  },
  methods: {
    getAlignment() {
      if (
        this.con.type === "user" ||
        (this.con.sender && this.con.sender.sender_type === "USER")
      ) {
        return "justify-end";
      } else if (this.con.type === "bot") {
        return "justify-start";
      }
    },
    getColor() {
      if (
        this.con.type === "user" ||
        (this.con.sender && this.con.sender.sender_type === "USER")
      ) {
        return "botter-user-text";
      } else if (this.con.type === "bot") {
        return "botter-bot-text";
      }
      return "botter-bot-text";
    },
  },
  computed: {
    lastMessageGroup() {
      return true;
    },
  },
  watch: {
    // 'con.payload': function () {
    //   let arabic = /[\u0600-\u06FF]/
    //   let input = document.getElementsByClassName('botter-text')
    //   for (let i=0; i<input.length;i++) {
    //     if (arabic.test(this.userInput) && input.style) {
    //       input.style.direction = 'rtl'
    //     } else  {
    //       input.style.direction = 'ltr'
    //     }
    //   }
    // }
  },
};
</script>

<style lang="scss">
.botter-text {
  margin-top: 10px;
  padding: 15px;

  display: flex;
  border-radius: 5px;
  p {
    word-break: break-word;
    padding: 0;
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    width: 100%;
  }
}
.botter-user-text {
  background: var(--primaryColor);
  color: white;
  width: auto;
  max-width: 70%;
}
.botter-bot-text {
  background: #eaf0f7;
  width: 100%;
  max-width: 100%;
  color: black;
}
</style>
